import toyboiLogo from "../assets/images/toyboi.png";
import cubiksLogo from "../assets/images/cubiks.png";

export default function About() {
    return (
        <section id="about" className="about-section py-5">
            <div className="container">
                <h2 className="section-title mb-5">About Our Company</h2>
                <div className="row align-items-center">
                    {/* Card Section */}
                    <div className="col-md-6">
                        <div className="about-card">
                            <p>
                                <strong>Anand Tech Plast Pvt. Ltd.</strong> is a professional toy manufacturing company specializing in research and development of high-quality toys. Over the years, we have gained rich experience and advanced techniques in creating creatively motivated and artistically oriented toys for children. Our factories, located in Bhopal and Mumbai, span over 10,000 square meters of workshops and are equipped with 20+ injection molding machines and 25+ assembly lines.
                            </p>
                            <p>
                                Quality control is always our priority, aimed at adding value to our brands <strong>ToyBoi</strong> and <strong>Cubiks</strong>. Designed to be educational, intelligent, and full of vitality, our products are ideal companions for children, helping them lead happier, healthier, and more successful lives. All our products have been tested, approved, and certified by <strong>BIS</strong>.
                            </p>
                        </div>
                    </div>
                    {/* Logo Section */}
                    <div className="col-md-6 d-flex flex-column align-items-center logos-section">
                        {/* ToyBoi Logo linked */}
                        <a href="https://toyboi.co.in/" target="_blank" rel="noopener noreferrer">
                            <img
                                src={toyboiLogo}
                                alt="ToyBoi Logo"
                                className="brand-logo mb-4"
                            />
                        </a>

                        {/* Cubiks Logo linked */}
                        <a href="https://cubiks.in/" target="_blank" rel="noopener noreferrer">
                            <img
                                src={cubiksLogo}
                                alt="Cubiks Logo"
                                className="brand-logo"
                            />
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}
